import { useStore } from "../store/Store";
import Footer from "../components/Footer";

export default function ContactPage({ onNav }) {
  const { adminWhatsApp: WA_NUM } = useStore();

  return (
    <div className="page-top-pad" style={{ background:"white", minHeight:"100vh" }}>
      <div style={{ background:"linear-gradient(135deg,#1a1a2e,#2d1b69)", padding:"28px clamp(16px,4vw,40px)" }}>
        <h1 style={{ fontFamily:"'Playfair Display',serif", fontSize:"clamp(22px,4vw,34px)", fontWeight:900, color:"white" }}>Contact Us</h1>
        <p style={{ fontSize:13, color:"rgba(255,255,255,0.7)", marginTop:6 }}>We'd love to hear from you</p>
      </div>

      <div style={{ maxWidth:760, margin:"0 auto", padding:"clamp(24px,5vw,48px) clamp(16px,4vw,40px)" }}>
        <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(220px,1fr))", gap:16, marginBottom:32 }}>
          <a href={`https://wa.me/${WA_NUM}`} target="_blank" rel="noreferrer"
            style={{ background:"#F0FDF4", border:"1px solid #86EFAC", borderRadius:16, padding:22, textDecoration:"none", textAlign:"center" }}>
            <div style={{ fontSize:32, marginBottom:8 }}>💬</div>
            <div style={{ fontWeight:800, color:"#16A34A", fontSize:14, marginBottom:4 }}>WhatsApp Us</div>
            <div style={{ fontSize:12, color:"#666" }}>Fastest way to reach us — 9am to 9pm daily</div>
          </a>

          <div style={{ background:"#FDF2F8", border:"1px solid #FBCFE8", borderRadius:16, padding:22, textAlign:"center" }}>
            <div style={{ fontSize:32, marginBottom:8 }}>📍</div>
            <div style={{ fontWeight:800, color:"#EC4899", fontSize:14, marginBottom:4 }}>Visit Our Showroom</div>
            <div style={{ fontSize:12, color:"#666" }}>Gulmandi Corner, Chhatrapati Sambhajinagar, Maharashtra 431001</div>
          </div>

          <div style={{ background:"#F5F3FF", border:"1px solid #DDD6FE", borderRadius:16, padding:22, textAlign:"center" }}>
            <div style={{ fontSize:32, marginBottom:8 }}>🕐</div>
            <div style={{ fontWeight:800, color:"#7C3AED", fontSize:14, marginBottom:4 }}>Store Hours</div>
            <div style={{ fontSize:12, color:"#666" }}>Mon – Sun: 10:00 AM – 9:00 PM</div>
          </div>
        </div>

        <div style={{ background:"#fafafa", borderRadius:16, padding:24, textAlign:"center" }}>
          <div style={{ fontFamily:"'Playfair Display',serif", fontSize:20, fontWeight:900, color:"#1a1a2e", marginBottom:8 }}>Since 1979</div>
          <p style={{ fontSize:13, color:"#666", lineHeight:1.7 }}>
            Matchwell has been serving the women of Chhatrapati Sambhajinagar for over four decades. Whether it's a
            question about an order, a product, or just some styling advice — our team is always happy to help.
          </p>
        </div>
      </div>
      <Footer onNav={onNav}/>
    </div>
  );
}
